import LeafletMap from "./components/LeafletMap.js"

function App() {

  return (
    <LeafletMap />
  )
}

export default App
